module.exports = __webpack_public_path__ + "img/media (2).cde54372.png";